export const SET_RESULTS = "SET_RESULTS";
export const SET_SELECTED_RESULT = "SET_SELECTED_RESULT";
